/**
 * Created by Slava Ivanov 13.10.22
 */

const TapToContinue = cc.Node.extend({
    ctor: function (options) {
        this._super();

        const text = this.text = cleverapps.UI.generateOnlyText(options.text, options.font || cleverapps.styles.FONTS.CLOSE_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        this.setAnchorPoint(0.5, 0.5);

        this.addChild(text);

        this.setCascadeOpacityEnabled(true);

        this.setOpacity(0);
        this.setVisible(false);
        this.onResize();
    },

    onResize: function () {
        const text = this.text;

        const sceneWidth = cleverapps.resolution.getSceneSize().width;
        const isVertical = cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL;

        if (isVertical) {
            text.setDimensions(sceneWidth, 0);
        }

        text.setAlignment(text.width / 2, text.height / 2);
        this.setContentSize(text.getContentSize());

        const scale = (sceneWidth - cleverapps.styles.TapToContinue.padding) / this.width;
        const newScale = Math.min(scale, isVertical ? 0.8 : 1);

        this.setScale(newScale);
    },

    hide: function (silent) {
        this.stopAllActions();

        if (silent) {
            this.setVisible(false);
            return;
        }

        this.runAction(new cc.Sequence(
            new cc.FadeOut(0.1),
            new cc.Hide()
        ));
    },

    show: function () {
        this.runAction(
            new cc.Sequence(
                new cc.FadeOut(0),
                new cc.DelayTime(0.5),
                new cc.Show(),
                new cc.FadeIn(1)
            )
        );
    }
});

cleverapps.styles.TapToContinue = {
    padding: 100
};
